import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, Button, Flex, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../hooks/useAuth";
import { fetchDocumentsAsync } from "../features/documents/documentsSlice";
import Search from "antd/es/input/Search";
import { DownloadOutlined } from "@ant-design/icons";
import { doArraysOverlap } from "../util/array";
import { Link } from "react-router-dom";
import axios from "axios";
import fileDownload from "js-file-download";

export default function DocumentItems() {
    // const { download } = useDownloader({ mode: "no-cors", forceDownload: true });
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [searchKey, setSearchkey] = useState("");
    const { auth } = useAuth();
    const dispatch = useDispatch();

    const data = useSelector((state) => state.documents.documents);
    const status = useSelector((state) => state.documents.status);
    const error = useSelector((state) => state.documents.error);

    useEffect(() => {
        if (status === "idle" || (status === "fulfilled" && data === null)) {
            dispatch(fetchDocumentsAsync(auth.getUser().id));
        }
    }, [auth, data, dispatch, status]);

    const getAllCategories = useMemo(() => {
        if (!data || data.length === 0) return [];
        const categories = data[0].attributes?.documents
            ?.map((item) => item.categories.data?.map((category) => category.attributes.name))
            .flat();
        return [...new Set(categories)];
    }, [data]);

    if (status === "pending" || data === null) return <div className="AlertInfo Loading">Loading...</div>;
    if (error) return <p>Error :(</p>;

    if (data.length === 0) return <p>No documents found</p>;

    const openFile = (item) => {
        const url = item.file.data.attributes.url;
        // download file by url
        window.open(url, "_blank");
    };

    const downloadFile = (item) => {
        const filename = new URL(item.file.data.attributes.url).pathname.split("/").pop();
        const url = item.file.data.attributes.url;
        axios
            .get(url, {
                responseType: "blob",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Methods": "GET",
                }
            })
            .then((res) => {
                fileDownload(res.data, filename);
            });
    };

    const getCategories = (item) => {
        return item.categories.data?.map((category) => category.attributes.name).join(", ");
    };

    const getDocuments = () => {
      console.log('>>>> data', data)
        if (searchKey === "" && selectedCategories.length === 0) return data[0].attributes?.documents;
        return data[0].attributes?.documents.filter((item) => {
            const itemCategory = getCategories(item).toLowerCase();
            return (
                (searchKey.length > 0 &&
                    (item.name.toLowerCase().includes(searchKey.toLowerCase()) || itemCategory.includes(searchKey.toLowerCase()))) ||
                doArraysOverlap(selectedCategories, itemCategory.split(", "))
            );
        });
    };

    return (
        <div>
            <Search
                size="large"
                placeholder="Search documents"
                allowClear
                onChange={(event) => setSearchkey(event.target.value)}
                enterButton
                value={searchKey}
            />
            <Flex wrap="wrap" style={{ marginTop: "30px" }} className="FilterTags">
                {getAllCategories?.map((category) => (
                    <Tag
                        color="default"
                        key={category}
                        className={selectedCategories.includes(category.toLowerCase()) ? "Active" : null}
                        onClick={() => {
                            if (selectedCategories.includes(category.toLowerCase())) {
                                setSelectedCategories(selectedCategories.filter((item) => item !== category.toLowerCase()));
                            } else {
                                setSelectedCategories([...selectedCategories, category.toLowerCase()]);
                            }
                        }}
                    >
                        {category}
                    </Tag>
                ))}
            </Flex>

            <Row gutter={[20, 20]} style={{ marginTop: "50px" }}>
                {getDocuments()?.map((item) => (
                    <Col span={24}>
                        <div className="CardDocumentsWrap">
                            <Card onClick={() => openFile(item)} className="CardItem CardDocuments">
                                <h3>
                                    {item.name}{" "}
                                    {item.categories.data?.length > 0 && (
                                        <>
                                            - <Tag className="SingleTag">{getCategories(item)}</Tag>
                                        </>
                                    )}
                                </h3>
                            </Card>
                            <Button onClick={() => downloadFile(item)} shape="round" icon={<DownloadOutlined />}>
                                Download
                            </Button>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
}
